import React, { useEffect, useState, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';

import './Inicio.css';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import { useCart } from '../../context/CartContext';
import WhatsAppWidget from '../../components/WhatsAppWidget';

const API_CURSOS = 'https://centrocomunicar.com/api-comunicar/endpoints/courses.php?action=list';
const API_HERO   = 'https://centrocomunicar.com/api-comunicar/endpoints/hero_carrusel.php';

/* ════════ LOGO ════════ */
const LogoComunicar = ({ height = 40 }) => (
  <img 
    src="/images/logo_centro.png" 
    alt="Comunicar" 
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

/* ════════ ICONS ════════ */
const IconArrow     = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevLeft  = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevRight = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconStar      = () => (<svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconCheck     = () => (<svg viewBox="0 0 20 20" fill="none" width="18" height="18" style={{flexShrink:0}}><circle cx="10" cy="10" r="9" fill="rgba(139,202,175,.25)"/><path d="M6 10l3 3 5-5" stroke="#8BCAAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCart      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBag       = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconUsers     = () => (<svg viewBox="0 0 24 24" fill="none" width="12" height="12"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCalendar  = () => (<svg viewBox="0 0 24 24" fill="none" width="12" height="12"><rect x="3" y="4" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2"/><path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const DIFERENCIAL = [
  { texto: 'Cursos que te enseñan exactamente qué hacer en terapia' },
  { texto: 'Materiales descargables para usar con tus pacientes' },
  { texto: 'Todo pensado para que lo apliques desde la primera sesión' },
];

const TESTIMONIOS = [
  { nombre:'Rosario López',  ocupacion:'Terapeuta del habla y lenguaje, Santo Domingo, República Dominicana', texto:'Para mí las formaciones de comunicar han sido de mucha ayuda para seguir capacitándome, son prácticos y de fácil acceso. Muy útiles para estar actualizados ❤️', estrellas:5 },
  { nombre:'Gloria Zapata',  ocupacion:'Psicóloga especialista en trastornos de la comunicación y lenguaje, Trujillo, Perú', texto:'Comunicar no solo aporta conocimientos, sino que también brinda herramientas útiles y actualizadas para el ejercicio profesional. Estoy muy agradecida por todo lo aprendido.', estrellas:5 },
  { nombre:'Liana Martínez', ocupacion:'Especialista en aprendizaje, comunicación y lenguaje, Lima, Perú', texto:'Los cursos que recibí han significado un aporte muy importante en mi desarrollo profesional. Valoro mucho el enfoque práctico de los cursos, esto hace que tenga un impacto real en la práctica diaria.', estrellas:5 },
];

const SLIDES_FALLBACK = [
  {
    id:'cursos', modo:'contenido',
    tag:'Formación especializada',
    titulo:'¡Aprende exactamente\nqué hacer en terapia!',
    subtitulo:'Cursos prácticos',
    descripcion:'Cursos diseñados por especialistas en lenguaje, comunicación, habla y otras áreas.',
    items:['Cursos grabados a tu ritmo','Formaciones en vivo con expertos','Certificado oficial al completar'],
    btn1_texto:'Ver Cursos', btn1_link:'/formaciones',
    btn2_texto:'Explorar gratis', btn2_link:'/formaciones#gratuitos',
    bg_clase:'slide--cursos',
    card:{ titulo:'Evaluación del Lenguaje en niños', precio:'S/. 120', stat:'320 estudiantes inscritos', badge1:'★ 4.9 valoración', badge2:'🎓 Certificado incluido' },
  },
  {
    id:'materiales', modo:'contenido',
    tag:'Materiales terapéuticos',
    titulo:'Recursos listos para\nusar desde hoy',
    subtitulo:'Aplicable desde la primera sesión.',
    descripcion:'Imprimibles, cuadernillos y juegos terapéuticos organizados por área y nivel de desarrollo.',
    items:['Imprimibles listos para usar','Cuadernillos de trabajo','Juegos terapéuticos validados'],
    btn1_texto:'Ver Materiales', btn1_link:'/recursos',
    btn2_texto:'Ver materiales gratis', btn2_link:'/recursos#gratuitos',
    bg_clase:'slide--materiales',
    card:{ titulo:'Kit Imprimible Fonología', precio:'S/. 25', stat:'180 descargas este mes', badge1:'✓ Listo para imprimir', badge2:'📥 Descarga inmediata' },
  },
];

/* ════════ TOAST ════════ */
function ToastCarrito({ item, onVer, onCerrar }) {
  useEffect(() => { const t = setTimeout(onCerrar, 3500); return () => clearTimeout(t); }, [onCerrar]);
  return (
    <div style={{position:'fixed',bottom:'2rem',right:'2rem',zIndex:9999,background:'#032D29',color:'#fff',borderRadius:16,padding:'1rem 1.2rem',boxShadow:'0 8px 32px rgba(0,0,0,.35)',display:'flex',alignItems:'center',gap:'1rem',maxWidth:320,width:'90%'}}>
      <div style={{width:38,height:38,borderRadius:10,background:'#8BCAAF',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><IconCheck/></div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'.72rem',color:'rgba(255,255,255,.5)',marginBottom:'.1rem'}}>Agregado al carrito</div>
        <div style={{fontSize:'.86rem',fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item?.titulo}</div>
      </div>
      <button onClick={onVer} style={{background:'#8BCAAF',color:'#032D29',border:'none',borderRadius:100,padding:'.4rem .85rem',fontFamily:'inherit',fontWeight:700,fontSize:'.75rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>Ver carrito</button>
    </div>
  );
}

/* ════════ CARD CURSO — con badge "ACCESO POR X DÍAS" igual al PDF ════════ */
function CursoCard({ curso }) {
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();
  const navigate = useNavigate();
  const enCarrito = estaEnCarrito('curso-' + curso.id);
  const precio    = parseFloat(curso.precio_web || 0);
  const cats      = ['lenguaje','tea','habla','aprendizaje'];
  const cat       = (curso.categoria || '').toLowerCase();
  const colorCls  = cats.includes(cat) ? cat : 'lenguaje';

  /* Badge acceso — viene de etiqueta, mock si no hay */
  const acceso = (curso.etiqueta && curso.etiqueta.toUpperCase().includes('ACCESO'))
  ? curso.etiqueta
  : 'ACCESO POR 6 MESES';

  /* Tipo de curso — badge negro superior */
  const tipoBadge = curso.tipo_badge || curso.seccion === 'en_vivo'
    ? 'CURSO EN VIVO'
    : curso.seccion === 'proximos'
    ? 'PRÓXIMO CURSO'
    : 'CURSO FORMATIVO';

  /* Subtipo del badge — segunda línea */
  const tipoBadge2 = curso.subtipo_badge || (curso.categoria || '').toUpperCase();

  /* Etiqueta especial sobre imagen — "NUEVO CURSO", "MÁS VENDIDO" */
  const etiquetaImg = curso.etiqueta_imagen || null;

  /* Tipo disponibilidad */
  const tipoLabel = curso.seccion === 'en_vivo' || curso.seccion === 'proximos'
    ? 'PRÓXIMO INICIO'
    : 'DISPONIBLE – CLASE GRABADA';

  return (
    <div className="dest-card">

      {/* ── THUMB ── */}
      <div className={`dest-card__thumb dest-card__thumb--${colorCls}`}>
        {(curso.imagen_custom || curso.imagen_url) && (
          <img
            src={curso.imagen_custom || curso.imagen_url}
            alt={curso.fullname}
            style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover'}}
          />
        )}

        {/* Badge negro superior izquierda — "CURSO CORTO / EVALUACIÓN DEL LENGUAJE INFANTIL" */}
        <div className="dest-card__tipo-badge">
          <span className="dest-card__tipo-badge-main">{tipoBadge}</span>
          {tipoBadge2 && <span className="dest-card__tipo-badge-sub">{tipoBadge2}</span>}
        </div>

        {/* Barra verde inferior — "ACCESO POR 14 DÍAS" */}
        <div className="dest-card__acceso">
          {acceso}
        </div>
      </div>

      {/* ── BODY ── */}
      <div className="dest-card__body">
        <span className="dest-card__tipo-label">{tipoLabel}</span>
        <h3 className="dest-card__titulo" style={{
          fontWeight: curso.titulo_negrita ? 700 : 300,
          textTransform: curso.titulo_minusculas ? 'none' : 'uppercase',
        }}>
          {curso.titulo_custom || curso.fullname}
        </h3>
       {/*  {curso.shortname && (
          <p className="dest-card__codigo">{curso.shortname}</p>
        )}*/}
        {curso.descripcion_custom && (
          <p className="dest-card__desc">
            {curso.descripcion_custom.slice(0,90)}{curso.descripcion_custom.length>90?'…':''}
          </p>
        )}
        <div className="dest-card__meta">
          {curso.total_estudiantes > 0 && <span><IconUsers/>{curso.total_estudiantes} alumnos</span>}
          {curso.fecha_inicio && <span><IconCalendar/>{curso.fecha_inicio}</span>}
        </div>
      </div>

      {/* ── FOOTER ── */}
      <div className="dest-card__footer">
        <strong className="dest-card__precio">
          S/. {precio.toFixed(0)}
          {curso.precio_anterior && (
            <s style={{fontSize:'.72rem',color:'#9ca3af',marginLeft:'.4rem',fontWeight:400}}>
              S/. {parseFloat(curso.precio_anterior).toFixed(0)}
            </s>
          )}
        </strong>
        <div style={{display:'flex',gap:'.4rem',alignItems:'center'}}>
          {precio > 0 && (
            enCarrito ? (
              <button className="dest-card__btn-carrito dest-card__btn-carrito--ok"
                onClick={() => navigate('/carrito')}>
                <IconBag/> Ver carrito
              </button>
            ) : (
              <button className="dest-card__btn-carrito"
                onClick={() => {
                  if (!estaLogueado) { navigate('/login?redirect=/formaciones'); return; }
                  agregarItem({ id:'curso-'+curso.id, titulo:curso.fullname, precio, tipo:'curso', color:'verde', imagen:curso.imagen_url||null, digital:true });
                }}>
                <IconCartPlus/> + Carrito
              </button>
            )
          )}
          <Link to={'/formaciones/'+curso.id} className="dest-card__btn-ver">
            Ver curso →
          </Link>
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function Inicio() {
  const { estaLogueado, usuario } = useAuthUser();
  const { totalItems, ultimoAgregado, limpiarUltimoAgregado, agregarItem, estaEnCarrito } = useCart();

  const navigate = useNavigate();

  const [slides,      setSlides]      = useState([]);
  const [slidesListo, setSlidesListo] = useState(false);
  const [slideActivo, setSlideActivo] = useState(0);
  const [animando,    setAnimando]    = useState(false);
  const intervalRef = useRef(null);
  const heroRef = useRef(null);
  const [btnHeroVisible, setBtnHeroVisible] = useState(true);

  const [cursosDestacados,     setCursosDestacados]     = useState([]);
  const [loadingCursos,        setLoadingCursos]        = useState(true);
  const [materialesDestacados, setMaterialesDestacados] = useState([]);
  const [loadingMateriales,    setLoadingMateriales]    = useState(true);

  /* Fetch hero */
  useEffect(() => {
    fetch(API_HERO + '?action=list')
      .then(r => r.json())
      .then(j => {
        if (j.success && j.data?.length > 0) {
          setSlides(j.data);
        } else {
          setSlides(SLIDES_FALLBACK);
        }
      })
      .catch(() => { setSlides(SLIDES_FALLBACK); })
      .finally(() => setSlidesListo(true));
  }, []);


  useEffect(() => {
    console.log('SLIDES:', slides);
  }, [slides]);

  /* Fetch cursos */
  useEffect(() => {
    fetch(API_CURSOS)
      .then(r => r.json())
      .then(j => {
        if (j.success && j.data) {
          const dest = j.data.filter(c => c.destacado && c.precio_web > 0).slice(0,3);
          setCursosDestacados(dest.length > 0 ? dest : j.data.filter(c => c.precio_web > 0).slice(0,3));
        }
      })
      .catch(() => {})
      .finally(() => setLoadingCursos(false));
  }, []);

  /* Fetch materiales */
  useEffect(() => {
    fetch('https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php?action=list')
      .then(r => r.json())
      .then(j => {
        if (j.success && j.data?.length > 0) {
          const dest = j.data.filter(r => r.destacado);
          const resto = j.data.filter(r => !r.destacado);
          setMaterialesDestacados([...dest,...resto].slice(0,3));
        }
      })
      .catch(() => {})
      .finally(() => setLoadingMateriales(false));
  }, []);

  /* Carrusel */
  const totalSlides = slides.length;
  const irASlide = useCallback((idx) => {
    if (animando) return;
    setAnimando(true);
    setTimeout(() => { setSlideActivo(idx); setAnimando(false); }, 350);
  }, [animando]);
  const siguiente = useCallback(() => irASlide((slideActivo+1)%totalSlides), [slideActivo,irASlide,totalSlides]);
  const anterior  = useCallback(() => irASlide((slideActivo-1+totalSlides)%totalSlides), [slideActivo,irASlide,totalSlides]);

  useEffect(() => {
    intervalRef.current = setInterval(siguiente, 6000);
    return () => clearInterval(intervalRef.current);
  }, [siguiente]);



  useEffect(() => {
    const update = () => {
      setBtnHeroVisible(window.scrollY < 30);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [slidesListo]);



  const pausar   = () => clearInterval(intervalRef.current);

  const reanudar = () => { intervalRef.current = setInterval(siguiente, 6000); };

  /* Reveal */
  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } }),
      { threshold: 0.08 }
    );
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
    return () => io.disconnect();
  }, [loadingCursos, loadingMateriales]);

  const slide = slides[slideActivo] || slides[0] || SLIDES_FALLBACK[0];

  return (
    <div className="inicio">

      {ultimoAgregado && (
        <ToastCarrito
          item={ultimoAgregado}
          onVer={() => { navigate('/carrito'); limpiarUltimoAgregado(); }}
          onCerrar={limpiarUltimoAgregado}
        />
      )}

      {/* ══ NAV ══ */}
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones">Cursos</Link>
          <Link to="/recursos">Materiales</Link>
          <Link to="/comunidad">Comunidad</Link>
          <Link to="/articulos">Blog</Link>

          <a href="https://centrocomunicar.com/virtual/login/index.php"
            target="_blank" rel="noopener noreferrer"
            className="nav__aula-btn">
            <span className="aula-icon">📖</span>
            Aula Virtual
          </a>

        </div>
        
        <div className="nav__actions">
          <Link to="/carrito" style={{position:'relative',display:'flex',alignItems:'center',padding:'.4rem .7rem',borderRadius:100,border:'1.5px solid rgba(139,202,175,.3)',color:'var(--gris)',transition:'all .2s'}}>
            <IconCart/>
            {totalItems > 0 && (
              <span style={{position:'absolute',top:-6,right:-6,background:'#8BCAAF',color:'#032D29',borderRadius:'50%',width:18,height:18,fontSize:'.62rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                {totalItems>9?'9+':totalItems}
              </span>
            )}
          </Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      {/* ══ HERO CARRUSEL ══ */}
         <div ref={heroRef} style={{position:'relative'}}>

      {!slidesListo && (
        <div style={{height:'calc(100vw * 0.364)',minHeight:500,maxHeight:750,background:'#032D29'}}/>
      )}
   
      {slidesListo && (
    
    
    <section
  className={`hero-carousel ${slide.bg_clase||slide.bg||''} ${animando?'hero-carousel--saliendo':'hero-carousel--entrando'}`}
  style={slide.imagen_url ? {
    backgroundImage:`url(${slide.imagen_url})`,
    backgroundSize:'100% 100%',
    backgroundPosition:'top center',
    backgroundRepeat:'no-repeat'
  } : {}}
  onMouseEnter={pausar}
  onMouseLeave={reanudar}
>
  <div className="hero-carousel__bg">

         <div className="hc__blob hc__blob--a"/>
          <div className="hc__blob hc__blob--b"/>
        </div>
       
             <div className="hero-carousel__inner"

        
  style={slide.modo === 'imagen' ? {pointerEvents:'none'} : {}}>
  <div className="hero-carousel__content">
    {slide.modo === 'imagen' ? null : (

              <>
                {slide.subtitulo && <p className="hc__super">{slide.subtitulo}</p>}
                {slide.tag && <span className="hc__tag">{slide.tag}</span>}
                <h1 className="hc__titulo">
                  {(slide.titulo||'').split('\n').map((line,i) => (
                    <span key={i}>{line}{i===0&&<br/>}</span>
                  ))}
                </h1>
                {slide.descripcion && <p className="hc__desc">{slide.descripcion}</p>}
                {slide.items?.length > 0 && (
                  <ul className="hc__lista">
                    {slide.items.filter(Boolean).map(it => (<li key={it}><IconCheck/>{it}</li>))}
                  </ul>
                )}
                <div className="hc__btns">
                  {/* Botón primario ROJO como en PDF */}
                  {slide.btn1_texto && <Link to={slide.btn1_link||'/'} className="hc__btn hc__btn--primary">{slide.btn1_texto}</Link>}
                  {slide.btn2_texto && <Link to={slide.btn2_link||'/'} className="hc__btn hc__btn--ghost">{slide.btn2_texto}</Link>}
                </div>
              </>
            )}
          </div>
          <div className="hero-carousel__visual">
            <div className="hc__card-stack">
              {slide.modo !== 'imagen' && slide.card && (
                <>
                  <div className="hc__card hc__card--main">
                    <div className="hc__card-tag">{slide.card.titulo?'🎓 Destacado':'📦 Material destacado'}</div>
                    <h3>{slide.card.titulo||''}</h3>
                    {slide.card.stat  && <p>{slide.card.stat}</p>}
                    {slide.card.precio && <div className="hc__card-price">{slide.card.precio}</div>}
                    <Link to={slide.btn1_link||'/'} className="hc__card-btn">Ver ahora →</Link>
                  </div>
                  {slide.card.badge1 && <div className="hc__card hc__card--badge hc__card--badge-a">{slide.card.badge1}</div>}
                  {slide.card.badge2 && <div className="hc__card hc__card--badge hc__card--badge-b">{slide.card.badge2}</div>}
                </>
              )}
            </div>
          </div>
        </div>
        <button className="hc__arrow hc__arrow--left"  onClick={anterior}  aria-label="Anterior"><IconChevLeft/></button>
        <button className="hc__arrow hc__arrow--right" onClick={siguiente} aria-label="Siguiente"><IconChevRight/></button>
        <div className="hc__dots">
          {slides.map((_,i) => (
            <button key={i} className={`hc__dot ${i===slideActivo?'hc__dot--active':''}`} onClick={() => irASlide(i)} aria-label={`Slide ${i+1}`}/>
          ))}
        </div>




    





        <div className="hc__progress"><div className="hc__progress-bar" key={slideActivo}/></div>
      </section>
      )}


{slidesListo && slide.modo === 'imagen' && btnHeroVisible && createPortal(
        <Link
          to={slide.btn1_link || slide.imagen_link || '/formaciones'}
          className="hc__btn hc__btn--primary"
          style={{
            position:'fixed', bottom:'2.5rem', right:'3rem', zIndex:99999,
            background:'#e53e3e', color:'#fff',
            padding:'.78rem 1.8rem', borderRadius:'100px',
            fontWeight:700, fontSize:'.9rem',
            display:'inline-flex', alignItems:'center', gap:'.45rem',
            boxShadow:'0 4px 20px rgba(229,62,62,.45)',
            textDecoration:'none', whiteSpace:'nowrap',
            transition:'opacity .2s',
          }}
        >
          {slide.btn1_texto || 'Ver más'}
        </Link>,
        document.body
      )}


      </div>

      {/* ══ CURSOS DESTACADOS — fondo blanco ══ */}
      <section className="dest-section reveal" id="cursos-destacados">
        <div className="dest-section__inner">
          <div className="dest-section__head">
            <div>
              <p className="section-label">Oferta académica</p>
              <h2>Cursos <em>destacados</em></h2>
              <p className="dest-section__sub">Accede a contenido formativo sin costo. Solo regístrate con tu nombre y correo.</p>
            </div>
            <Link to="/formaciones" className="dest-section__cta">Explorar cursos <IconArrow/></Link>
          </div>
          {loadingCursos ? (
            <div className="dest-loading">Cargando cursos…</div>
          
          ) : cursosDestacados.length === 0 ? (
            <div className="dest-grid">
              {[
                { titulo:'EDNA - EVALUACIÓN DEL DISCURSO NARRATIVO', precio:'S/. 80', shortname:'CC202604EDN', tipoBadge:'CURSO CORTO', tipoBadge2:'INTEGRACIÓN SENSORIAL\nPRINCIPIOS PARA FORTALECER LA\nPRÁCTICA DE LA TERAPIA DE LENGUAJE', cat:'lenguaje', acceso:'ACCESO POR 14 DÍAS', tipoLabel:'DISPONIBLE – CLASE GRABADA', desc:'DISPONIBLE CLASE GRABADA Duración: 3 horas cronológicas. Aprende a evaluar la narrativa infantil…', alumnos:22, fecha:'26/04/2026' },
                { titulo:'EDNA - EVALUACIÓN DEL DISCURSO NARRATIVO', precio:'S/. 80', shortname:'CC202604EDN', tipoBadge:'CURSO FORMATIVO', tipoBadge2:'EVALUACIÓN DEL LENGUAJE\nINFANTIL', cat:'lenguaje', acceso:'ACCESO POR 5 MESES', tipoLabel:'DISPONIBLE – CLASE GRABADA', desc:'DISPONIBLE CLASE GRABADA Duración: 3 horas cronológicas. Aprende a evaluar la narrativa infantil…', alumnos:22, fecha:'26/04/2026' },
                { titulo:'EDNA - EVALUACIÓN DEL DISCURSO NARRATIVO', precio:'S/. 80', shortname:'CC202604EDN', tipoBadge:'CURSO FORMATIVO', tipoBadge2:'EVALUACIÓN DEL LENGUAJE\nINFANTIL', cat:'lenguaje', acceso:'ACCESO POR 5 MESES', tipoLabel:'DISPONIBLE – CLASE GRABADA', desc:'DISPONIBLE CLASE GRABADA Duración: 3 horas cronológicas. Aprende a evaluar la narrativa infantil…', alumnos:22, fecha:'26/04/2026' },
              ].map((c, i) => (
                <Link to="/formaciones" className="dest-card" key={i}
                  style={{'--delay':`${i*0.1}s`, display:'flex', flexDirection:'column', textDecoration:'none'}}>
                  <div className={`dest-card__thumb dest-card__thumb--${c.cat}`}>
                    <div className="dest-card__tipo-badge">
                      <span className="dest-card__tipo-badge-main">{c.tipoBadge}</span>
                      {c.tipoBadge2 && c.tipoBadge2.split('\n').map((l,j) => (
                        <span key={j} className="dest-card__tipo-badge-sub">{l}</span>
                      ))}
                    </div>
                    <div className="dest-card__acceso">{c.acceso}</div>
                  </div>
                  <div className="dest-card__body">
                    <span className="dest-card__tipo-label">{c.tipoLabel}</span>
                    <h3 className="dest-card__titulo">{c.titulo}</h3>
                    <p className="dest-card__codigo">{c.shortname}</p>
                    <p className="dest-card__desc">{c.desc}</p>
                    <div className="dest-card__meta">
                      <span><IconUsers/>{c.alumnos} alumnos</span>
                      <span><IconCalendar/>{c.fecha}</span>
                    </div>
                  </div>
                  <div className="dest-card__footer">
                    <strong className="dest-card__precio">{c.precio}</strong>
                    <div style={{display:'flex',gap:'.4rem'}}>
                      <span className="dest-card__btn-carrito"><IconCartPlus/> + Carrito</span>
                      <span className="dest-card__btn-ver">Ver curso →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="dest-grid">
              {cursosDestacados.map((c,i) => (
                <div key={c.id} className="reveal" style={{'--delay':`${i*0.1}s`}}>
                  <CursoCard curso={c}/>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ══ MATERIALES DESTACADOS — fondo #032D29 ══ */}
      <section className="dest-section dest-section--mat reveal">
        <div className="dest-section__inner">
          <div className="dest-section__head">
            <div>
              <p className="section-label" style={{color:'#8BCAAF'}}>Recursos terapéuticos</p>
              <h2 style={{color:'#fff'}}>Materiales <em style={{color:'#8BCAAF'}}>destacados</em></h2>
              <p className="dest-section__sub" style={{color:'rgba(255,255,255,.55)'}}>Accede a contenido formativo sin costo. Solo regístrate con tu nombre y correo.</p>
            </div>
            <Link to="/recursos" className="dest-section__cta dest-section__cta--dark">Explorar materiales <IconArrow/></Link>
          </div>
          {loadingMateriales ? (
            <div className="dest-loading" style={{color:'rgba(255,255,255,.5)'}}>Cargando materiales…</div>
          ) : materialesDestacados.length === 0 ? (
            <div className="dest-grid">
            
           
            {[1,2,3].map(i => (
  <div key={i} className="dest-card dest-card--mat reveal" style={{'--delay':`${i*0.1}s`}}>
    <div className="dest-card__thumb dest-card__thumb--mat-rect"
      style={{background:'linear-gradient(135deg,#e8f5ef,#c8e8de)'}}>
      <div className="dest-card__dto-badge">30% Dto.</div>
    </div>
    <div className="dest-card__body">
      <span className="dest-card__cat-mat">Materiales</span>
      <h3 className="dest-card__titulo-mat">Construye Oraciones</h3>
      <p className="dest-card__desc">Plantillas de dados diseñadas para trabajar las estructuras básicas de las oraciones de manera lúdica y visual.</p>
      <div className="dest-card__mat-meta">
        <span>📄 PDF</span><span>🏷 26 págs.</span>
      </div>
      <div className="dest-card__rating">
        {[1,2,3,4,5].map(n=><span key={n} style={{color:'#f59e0b',fontSize:'1rem'}}>★</span>)}
        <span style={{fontWeight:700,marginLeft:'.2rem'}}>5</span>
        <span style={{color:'var(--gris)',fontWeight:400}}>· 3 ventas</span>
      </div>
    </div>
    <div className="dest-card__footer">
      <strong className="dest-card__precio">S/. 9</strong>
      <div style={{display:'flex',gap:'.4rem'}}>
        <span className="dest-card__btn-agregar">🛒 Agregar</span>
        <span className="dest-card__btn-detalle">Ver detalle</span>
      </div>
    </div>
  </div>
))}


            </div>
          ) : (
            <div className="dest-grid">
           
           

           {materialesDestacados.map((m, i) => {
  const TIPO_LABEL = { recurso:'Imprimible', kit:'Cuadernillo', juego:'Juego' };
  const dtoPct = m.precio_antes
    ? Math.round((1 - parseFloat(m.precio) / parseFloat(m.precio_antes)) * 100)
    : 30; /* mock 30% si no hay precio_antes */

  return (
    <Link to={`/recursos/${m.id}`} className="dest-card dest-card--mat reveal" key={m.id}
      style={{'--delay':`${i*0.1}s`}}>

      {/* THUMB — imagen rectangular 4:3 */}
      <div className="dest-card__thumb dest-card__thumb--mat-rect"
        style={m.imagen_url
          ? {backgroundImage:`url(${m.imagen_url})`,backgroundSize:'cover',backgroundPosition:'center'}
          : {background:'linear-gradient(135deg,#c8e8de,#8BCAAF)'}
        }
      >
        {/* Badge rojo descuento — esquina superior izquierda */}
        <div className="dest-card__dto-badge">
          {dtoPct}% Dto.
        </div>
      </div>

      {/* BODY */}
      <div className="dest-card__body">
        <span className="dest-card__cat-mat">Materiales</span>
        <h3 className="dest-card__titulo-mat">{m.titulo}</h3>
        {m.descripcion && (
          <p className="dest-card__desc">
            {m.descripcion.slice(0,85)}{m.descripcion.length>85?'…':''}
          </p>
        )}
        <div className="dest-card__mat-meta">
          {m.formato  && <span>📄 {m.formato}</span>}
          {m.paginas  && <span>🏷 {m.paginas} págs.</span>}
        </div>
        {m.rating > 0 && (
          <div className="dest-card__rating">
            {[1,2,3,4,5].map(n => (
              <span key={n} style={{color: n<=Math.round(m.rating)?'#f59e0b':'#d1d5db',fontSize:'1rem'}}>★</span>
            ))}
            <span style={{fontWeight:700,marginLeft:'.2rem'}}>{m.rating}</span>
            {m.ventas > 0 && <span style={{color:'var(--gris)',fontWeight:400}}>· {m.ventas} ventas</span>}
          </div>
        )}
      </div>

      {/* FOOTER */}
      <div className="dest-card__footer">
        <strong className="dest-card__precio">S/. {parseFloat(m.precio||0).toFixed(0)}</strong>
        <div style={{display:'flex',gap:'.4rem',alignItems:'center'}}>
        <button className="dest-card__btn-agregar"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              if (!estaLogueado) { navigate('/login?redirect=/recursos'); return; }
              agregarItem({
                id:               m.id,
                titulo:           m.titulo,
                precio:           parseFloat(m.precio || 0),
                tipo:             m.tipo,
                color:            m.color || 'verde',
                imagen:           m.imagen_url || null,
                descripcion_larga: m.descripcion_larga || null,
                imagenes:         m.imagenes || [],
                digital:          true,
              });
            }}>
            🛒 Agregar
          </button>
          <span className="dest-card__btn-detalle" onClick={e => e.stopPropagation()}>Ver detalle</span>

        </div>
      </div>
    </Link>
  );
})}

            </div>
          )}
        </div>
      </section>

      {/* ══ QUIÉNES SOMOS — fondo #EDFAF4 ══ */}
   {/* ══ QUIÉNES SOMOS — fondo #EDFAF4 ══ */}
<section className="quienes reveal">
  <div className="quienes__inner">
    <div className="quienes__col">
      <p className="section-label">Quiénes somos</p>
      <h2>Cómo nace<br/><em>Comunicar</em></h2>
      <p className="quienes__texto">Comunicar nace desde la práctica clínica, de lo que realmente pasa en sesión y de la necesidad de hacerlo más claro y aplicable.</p>
      <p className="quienes__texto">Hoy transformamos esa experiencia en formación y materiales diseñados para terapeutas que buscan herramientas concretas y basadas en evidencia.</p>
      <Link to="/comunidad" className="quienes__btn">Conocer la comunidad <IconArrow/></Link>
    </div>

    <div className="quienes__col quienes__col--diana">
   
   
    <div className="diana__card">

{/* Hijo 1 — col 1, fila 1 */}
<div className="diana__top">
  <p className="section-label">Sobre Diana</p>
</div>

{/* Hijo 2 — col 2, filas 1+2 */}
<div className="diana__avatar-wrap">
  <img src="/images/diana.jpg" alt="Diana Ayay" className="diana__avatar-img"/>
</div>

{/* Hijo 3 — col 1, fila 2 */}
<div className="diana__info">
    <h3>Soy Diana Ayay</h3>
          <p>Trabajo en terapia de lenguaje desde hace más de 10 años. A partir de esta experiencia, empecé a diseñar materiales y formaciones que respondan a una necesidad concreta: saber qué hacer en terapia.</p>
          <p>Hoy comparto herramientas diseñadas para hacer la intervención más clara, estructurada y aplicable, siempre pensando en lo que realmente funciona en sesión.</p>
          <div className="diana__tags">
            <span>Terapia de Lenguaje</span>
            <span>Tartamudez</span>
            <span>TDL</span>
            <span>Evaluación</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

      {/* ══ DIFERENCIAL — fondo #032D29 ══ */}
      <section className="diferencial reveal">
        <div className="diferencial__inner">
          <div className="diferencial__texto">
            <p className="section-label" style={{color:'#8BCAAF'}}>Por qué Comunicar</p>
            <h2>"No solo teoría.<br/><em>Aquí aprendes exactamente<br/>qué hacer en terapia."</em></h2>
            <ul className="diferencial__lista">
              {DIFERENCIAL.map(d => (<li key={d.texto}><IconCheck/><span>{d.texto}</span></li>))}
            </ul>
            <Link to="/formaciones" className="diferencial__btn">Explorar cursos <IconArrow/></Link>
          </div>
          <div className="diferencial__visual">
            <div className="dif__stat-grid">
              <div className="dif__stat"><strong>+500</strong><span>Profesionales formados</span></div>
              <div className="dif__stat"><strong>100%</strong><span>Aplicable en sesión</span></div>
              <div className="dif__stat"><strong>+5</strong><span>Países alcanzados</span></div>
              <div className="dif__stat"><strong>+30</strong><span>Formaciones dictadas</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ TESTIMONIOS — fondo blanco ══ */}
      <section className="testimonios reveal">
        <div className="testimonios__inner">
          <div className="testimonios__head">
            <p className="section-label">Comunidad real</p>
            <h2>Lo que dicen<br/><em>nuestros clientes</em></h2>
          </div>
          <div className="test-grid">
            {TESTIMONIOS.map((t,i) => (
              <div className="test-card reveal" key={t.nombre} style={{'--delay':`${i*0.12}s`}}>
                <div className="test-stars">{[...Array(t.estrellas)].map((_,j)=><IconStar key={j}/>)}</div>
                <p className="test-texto">"{t.texto}"</p>
                <div className="test-autor">
                  <div className="test-avatar">{t.nombre.charAt(0)}</div>
                  <div><strong>{t.nombre}</strong><span>{t.ocupacion}</span></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ FOOTER — fondo #032D29 ══ */}
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="footer__brand-desc">Cursos especializados y materiales terapéuticos para profesionales y familias que trabajan el desarrollo del lenguaje.</p>
            <div className="footer__social">
              <a href="https://www.instagram.com/comunicar_terapias" className="footer__social-btn" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg></a>
              <a href="https://www.facebook.com/comunicar.terapias"  className="footer__social-btn" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
              <a href="https://api.whatsapp.com/send/?phone=51940686868" className="footer__social-btn" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
            </div>
          </div>
          <div className="footer__cols">
            <div className="footer__col">
              <h4>Cursos</h4>
              <Link to="/formaciones">Cursos grabados</Link>
              <Link to="/formaciones">Cursos en vivo</Link>
              <Link to="/formaciones#calendario">Calendario académico</Link>
              <a href="https://centrocomunicar.com/virtual/login/index.php" target="_blank" rel="noopener noreferrer">Aula virtual ↗</a>
            </div>
            <div className="footer__col">
              <h4>Materiales</h4>
              <Link to="/recursos">Imprimibles</Link>
              <Link to="/recursos">Cuadernillos</Link>
              <Link to="/recursos">Juegos terapéuticos</Link>
            </div>
            <div className="footer__col">
              <h4>Comunidad</h4>
              <Link to="/comunidad">Redes sociales</Link>
              <Link to="/comunidad">Boletín mensual</Link>
              <Link to="/comunidad">Programa de puntos</Link>
            </div>
          </div>
          <div className="footer__newsletter">
            <h4>Recibe novedades</h4>
            <p>Materiales gratuitos y nuevos cursos directamente en tu correo.</p>
            <div className="footer__form">
              <input type="email" placeholder="tu@correo.com" className="footer__input"/>
              <button className="footer__submit" aria-label="Suscribirse"><IconArrow/></button>
            </div>
            <div className="footer__legal-links">
              <Link to="/atencion-cliente">Atención al cliente</Link>
              <Link to="/legal">Legal</Link>
              <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
          <p style={{fontSize:'.75rem',color:'rgba(255,255,255,.3)',marginTop:'.3rem'}}>Dirección: Teniente Carlos Moore 1386, Cercado de Lima</p>
          <div className="footer__legal">
            <Link to="/legal">Privacidad</Link>
            <Link to="/legal">Términos y condiciones</Link>
            <Link to="/politica-devoluciones">Política de devoluciones</Link>
          </div>
        </div>
      </footer>

     {/*  <WhatsAppWidget/> */}

      {/* Widget redes sociales flotante */}
      <div style={{position:'fixed',right:0,top:'50%',transform:'translateY(-50%)',zIndex:100,display:'flex',flexDirection:'column',gap:2}}>
        {[
          {href:'https://www.facebook.com/comunicar.terapias',bg:'#1877f2',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>},
          {href:'https://www.instagram.com/comunicar_terapias',bg:'#e1306c',icon:<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>},
          {href:'https://api.whatsapp.com/send/?phone=51940686868',bg:'#25d366',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>},
          {href:'https://www.youtube.com/@CentroComunicar',bg:'#ff0000',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>},
        ].map(({href,bg,icon}) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer"
            style={{width:40,height:40,background:bg,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',transition:'opacity .2s'}}
            onMouseEnter={e=>e.currentTarget.style.opacity='.8'}
            onMouseLeave={e=>e.currentTarget.style.opacity='1'}>
            {icon}
          </a>
        ))}
      </div>

    </div>
  );
}